<template>
  <el-dialog
    v-model="dialogStatus"
    :close-on-click-modal="false"
    @close="close"
    :title="dialogTitle"
    :width="width"
    append-to-body>
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="OCPX渠道" prop="channelId">
        <el-select v-model="form.channelId" placeholder="请选择渠道" size="medium" filterable style="width: 100%;">
          <el-option
            v-for="item in channelList"
            :key="item.id"
            :label="item.channelName"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="任务名称" prop="taskName">
        <el-input v-model="form.taskName" size="medium" placeholder="请输入任务名称"/>
      </el-form-item>
      <el-form-item label="广告主" prop="advertiserId">
        <el-select v-model="form.advertiserId" placeholder="请选择广告主" size="medium" filterable style="width: 100%;" @change="handleAdvertiserChange">
          <el-option
            v-for="item in advertiserList"
            :key="item.id"
            :label="item.advertiserName"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="转化类型" prop="conversionType">
        <el-select v-model="form.conversionType" placeholder="请选择转化类型" size="medium" style="width: 100%;">
          <el-option
            v-for="item in conversionTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="目标转化数" prop="targetConversionCount">
        <el-input-number v-model="form.targetConversionCount" :min="0" size="medium" style="width: 100%;" />
      </el-form-item>
      <el-form-item label="投放计划" prop="campaignId">
        <el-select v-model="form.campaignId" placeholder="请选择投放计划" size="medium" filterable style="width: 100%;">
          <el-option
            v-for="item in campaignList"
            :key="item.id"
            :label="item.campaignName"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="RTA 开关" prop="rtaOnoff">
        <el-radio-group v-model="form.rtaOnoff" @change="handleRtaOnoffChange">
          <el-radio :label="0">关闭</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form.rtaOnoff === 1" label="RTA 服务" prop="rtaId">
        <el-select v-model="form.rtaId" placeholder="请选择 RTA 服务" size="medium" filterable style="width: 100%;" clearable :disabled="form.rtaOnoff === 0">
          <el-option
            v-for="item in rtaList"
            :key="item.id"
            :label="item.rtaName"
            :value="item.id"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="假点击开关" prop="fakeClickOnoff">
        <el-radio-group v-model="form.fakeClickOnoff" @change="handleFakeClickOnoffChange">
          <el-radio :label="0">关闭</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form.fakeClickOnoff === 1" label="假点击比例" prop="fakeClickRate">
        <el-input-number v-model="form.fakeClickRate" :min="0" :max="100" size="medium" style="width: 100%;" />
        <span style="margin-left: 10px; color: #999;">(百分比，范围 0-100%)</span>
      </el-form-item>
      <el-form-item label="扣量开关" prop="deductOnoff">
        <el-switch
          v-model="form.deductOnoff"
          active-text="开启"
          inactive-text="关闭"
          @change="handleDeductOnoffChange"
        />
      </el-form-item>
      <el-form-item v-if="form.deductOnoff" label="扣量比例" prop="deductRate">
        <el-input-number v-model="form.deductRate" :min="0" :max="100" size="medium" style="width: 100%;" />
        <span style="margin-left: 10px; color: #999;">(百分比，范围 0-100%)</span>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="form.status">
          <el-radio :label="0">草稿</el-radio>
          <el-radio :label="1">投放中</el-radio>
          <el-radio :label="2">暂停</el-radio>
          <el-radio :label="3">已结束</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div style="text-align: right;">
      <el-button @click="close" size="medium">取消</el-button>
      <el-button @click="submit" type="primary" size="medium" :loading="submitLoading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addConversionTask, updateConversionTask } from '@/api/ocpx/conversionTask'
import { getEnabledAdvertiserList } from '@/api/ocpx/advertiser'
import { getEnabledChannelList } from '@/api/ocpx/channel'
import { getCampaignListByAdvertiserId } from '@/api/ocpx/campaign'
import { getEnabledRtaList } from '@/api/ocpx/conversionTask'
import { CONVERSION_TYPE_LIST } from '@/const/ocpx-conversion-type'

const defaultForm = {
  taskName: undefined,
  advertiserId: undefined,
  channelId: undefined,
  campaignId: undefined,
  conversionType: 1,
  targetConversionCount: undefined,
  rtaOnoff: 0,
  rtaId: undefined,
  fakeClickOnoff: 0,
  fakeClickRate: undefined,
  deductOnoff: false,
  deductRate: undefined,
  status: 0
}

export default {
  props: {
    title: String,
    width: {
      type: Number,
      default: 600
    }
  },
  emits: ['submit'],
  data () {
    return {
      dialogStatus: false,
      submitLoading: false,
      form: Object.assign({}, defaultForm),
      rules: {
        taskName: [{ required: true, message: '请输入任务名称', trigger: 'blur' }],
        advertiserId: [{ required: true, message: '请选择广告主', trigger: 'change' }],
        channelId: [{ required: true, message: '请选择渠道', trigger: 'change' }],
        campaignId: [{ required: true, message: '请选择投放计划', trigger: 'change' }],
        conversionType: [{ required: true, message: '请选择转化类型', trigger: 'change' }],
        targetConversionCount: [{ required: false, message: '请输入目标转化数', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      },
      advertiserList: [],
      channelList: [],
      campaignList: [],
      rtaList: [],
      isEdit: false,
      conversionTypeList: CONVERSION_TYPE_LIST
    }
  },
  computed: {
    dialogTitle () {
      return (this.title ? this.title : '') + (this.form.id ? '编辑' : '新增')
    }
  },
  created () {
    this.getAdvertiserList()
    this.getChannelList()
    this.getRtaList()
  },
  methods: {
    getAdvertiserList () {
      getEnabledAdvertiserList().then(res => {
        if (res.code === 200) {
          this.advertiserList = res.data || []
        }
      })
    },
    getChannelList () {
      getEnabledChannelList().then(res => {
        if (res.code === 200) {
          this.channelList = res.data || []
        }
      })
    },
    handleAdvertiserChange (advertiserId) {
      if (advertiserId) {
        getCampaignListByAdvertiserId(advertiserId).then(res => {
          if (res.code === 200) {
            this.campaignList = res.data || []
          }
        })
      } else {
        this.campaignList = []
      }
    },
    getRtaList () {
      getEnabledRtaList().then(res => {
        if (res.code === 200) {
          this.rtaList = res.data || []
        }
      })
    },
    handleRtaOnoffChange (value) {
      if (value === 0) {
        // 关闭 RTA 开关时，清空 RTA 服务选择
        this.form.rtaId = undefined
      }
    },
    handleFakeClickOnoffChange (value) {
      if (value === 0) {
        // 关闭假点击开关时，清空假点击比例
        this.form.fakeClickRate = undefined
      }
    },
    handleDeductOnoffChange (value) {
      if (!value) {
        // 关闭扣量开关时，清空扣量比例
        this.form.deductRate = undefined
      }
    },
    show (data) {
      this.dialogStatus = true
      if (data) {
        this.form = Object.assign({}, data)
        this.isEdit = true
        // 编辑模式下，如果有广告主ID，需要加载对应的投放计划列表以支持回显
        if (this.form.advertiserId) {
          this.handleAdvertiserChange(this.form.advertiserId)
        }
      }
    },
    close () {
      this.dialogStatus = false
      this.reset()
    },
    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.id) {
            this.doUpdate(this.form)
          } else {
            this.doAdd(this.form)
          }
        }
      })
    },
    doAdd (form) {
      this.submitLoading = true
      addConversionTask(form).then(res => {
        if (res.code === 200) {
          this.$message.success('新增成功')
          this.$emit('submit')
          this.close()
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    doUpdate (form) {
      this.submitLoading = true
      updateConversionTask(form).then(res => {
        if (res.code === 200) {
          this.$message.success('编辑成功')
          this.$emit('submit')
          this.close()
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    reset () {
      this.form = Object.assign({}, defaultForm)
      this.$refs.form && this.$refs.form.resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 15px;
}
</style>
